<template lang="html">
  <div class="body1">
    <Top selfStyle="padding-left: 0;"/>
    <StickList selfStyle="padding-left: 0;"/>
  </div>
</template>

<script>
import Top from '../../../components/Top.vue'
import StickList from '../../../components/TickerList.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('communication')
export default {
  components: {
    Top,
    StickList
  },
  data () {
    return {
      categoryId: 0
    }
  },
  methods: {
    ...mapGetters([
      'getTag'
    ])
  },
  computed: {
    getCategoryId () {
      return this.getTag()
    }
  }
}
</script>

<style lang="scss" scoped>
.body1 {
  width: 66.666666%;
}
@media screen and (max-width: 768px) {
  .body {
    flex-direction: column;
    justify-content: center;
    .body1 {
      width: 100%;
    }
  }
}
</style>
